import { Component, ViewChild, ElementRef, ChangeDetectorRef, numberAttribute } from '@angular/core';
import * as AOS from 'aos';
// import * as AOS from 'aos';
// import { LoginpopupService } from '../loginpopup.service';
// import { HideshowheaderfooterService } from '../hideshowheaderfooter.service';
// import { RestService } from '../rest.service';
import { RestService } from "../../services/rest.service";
import { CustomEventService } from '../../services/custom-event.service';
import { NgForm } from "@angular/forms";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
  public contactusSubmit='';
  footerCopyrightYear: any = "2025";
  postbody={"message":"","name":"","mobile":"","email":"","token":"","bs_name":"","bs_address":"","fname":"","lname":"","comments":""};
  wigetid:any;
  @ViewChild('recaptcha', {static: false }) recaptchaElement: any;
  showdloader = false;
  captchablank="1";
  showRecaptureError = '';
  constructor(
      public loginpopS: CustomEventService,
      // public hideShow: HideshowheaderfooterService,
      public restProvider: RestService,
      private cdr: ChangeDetectorRef
    ) {
      // this.hideShow.updateHideShowStatus(true);
      // this.hideShow.init();
    }
  ngOnInit(){
    this.addRecaptchaScript();
    let d1 = new Date();
    this.footerCopyrightYear = d1.getFullYear();
    AOS.init({disable: 'mobile'});//AOS - 2
    AOS.refresh();//refresh method is called on window resize and so on, as it doesn't require to build new store with AOS elements and should be as light as possible.
    const wrapper = document.getElementById("highlight-effect") as HTMLElement;
    const className = "in-view";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            wrapper?.classList.add(className);
            return;
          }

          wrapper?.classList.remove(className);
        });
      },
      {
        threshold: 1
      }
    );


    observer.observe(wrapper);
  }
  
  contactsubmit(f1:any,form:NgForm){
    // console.log(f1)
    // console.log(this.postbody);return;
    if(f1 && this.postbody.token!=''){
      this.showRecaptureError = ''
      this.postbody.name = this.postbody.fname +' '+ this.postbody.lname;
      this.postbody.message = "Business name: "+this.postbody.bs_name + ', Address:'+ this.postbody.bs_address +', '+"Message:"+this.postbody.comments + ', ' + '(it is come from landing page)';
      this.showdloader = true;
      this.restProvider
        .postdataapi(this.postbody, "information/contact_us")
        .subscribe((result: any) => {
          console.log(result)
          if(result.responsecode == '200'){
            this.contactusSubmit = "Thank you. We'll contact you soon.";
            this.showdloader = false;
            form.resetForm();
            this.showRecaptureError = ''
          }
          this.loginpopS.opencommonpopup("Sucess",result.status,"normal");
          setTimeout(()=>{
            this.contactusSubmit = "";
          },10000);
        })
        // .catch((error: any) => {
        //   console.log(error);
        //   this.loginpopS.opencommonpopup("Error",error,"normal");
        // }); 
    }else{
      if(this.postbody.token==''){
        this.showRecaptureError = 'yes';
      }
    }

    this.resetcaptcha();
  }
  resetcaptcha(){
    // console.log(this.wigetid);
    (window as { [key: string]: any })['grecaptcha'].reset();
    this.postbody.token="";
    this.captchablank="1";
    this.cdr.detectChanges();
  }

  renderReCaptch() {
    this.wigetid=(window as { [key: string]: any })['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : '6Ld70-4UAAAAAHO7zINRJL3czFod1Jc6VLT8GNId',
      'callback': (response:any) => {
          // console.log(response);
          this.showRecaptureError = '';
          this.postbody.token=response;
         // this.captchablank=false;
          this.captchaerrorreset();
      },
      'expired-callback': (response:any) =>{

        // console.log(response);
        this.showRecaptureError = 'yes';
        this.postbody.token="";
        this.captchablank="1";

      },
      'error-callback': (response:any) =>{

        // console.log(response);
        this.showRecaptureError = 'yes';
        this.postbody.token="";
        this.captchablank="1";

      }
      
    });
  }

  addRecaptchaScript() {
 
    (window as { [key: string]: any })['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }
 
    (function(d, s, id, obj){
      var js : any, fjs:any = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
 
  }

  captchaerrorreset(){

  // console.log("0");
  this.captchablank="0";
  this.cdr.detectChanges();

  // console.log(this.captchablank);
  }
}
